const IPV4_PATTERN = /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/
const DOMAIN_PATTERN = /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,24}$/
const PROTOCOL_PATTERN = /^[a-zA-Z][a-zA-Z\d+.-]*:\/\//

export function isValidUrl(value) {
  if (!value) return false
  const trimmed = String(value).trim()
  if (!trimmed || /\s/.test(trimmed)) return false

  const candidate = PROTOCOL_PATTERN.test(trimmed) ? trimmed : `https://${trimmed}`

  let parsed
  try {
    parsed = new URL(candidate)
  } catch (e) {
    return false
  }

  if (!/^https?:$/.test(parsed.protocol)) return false

  const hostname = parsed.hostname
  return hostname === 'localhost' || IPV4_PATTERN.test(hostname) || DOMAIN_PATTERN.test(hostname)
}
